module.exports = __webpack_public_path__ + "img/logo.b25b5a6a.png";